import React from "react";
import { withTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { connect } from "react-redux";
class IconSectionFeed extends React.Component {
  render() {
    const { t } = this.props;
    const feedTitle = [
      this.props.userType === "INDIVIDUAL"
        ? t("profile.about")
        : t("profile.businessInfo"),
      this.props.userType === "LOCAL BUSINESS"
        ? t("profile.businessCategory")
        : null,
      this.props.userType === "LOCAL BUSINESS"
        ? t("profile.licensesAndCertifications")
        : null,
      this.props.userType === "LOCAL BUSINESS"
        ? t("profile.businessOffering")
        : null,
      t("profile.posts"),
      t("profile.featured"),
      this.props.userType === "INDIVIDUAL" ? t("profile.interests") : null,
      this.props.userType === "INDIVIDUAL" ? t("profile.experience") : null,
      this.props.userType === "INDIVIDUAL" ? t("profile.education") : null,
      this.props.userType === "INDIVIDUAL"
        ? t("profile.licensesAndCertifications")
        : null,
      this.props.userType === "INDIVIDUAL"
        ? t("profile.volunteerExperience")
        : null,
      this.props.userType === "INDIVIDUAL"
        ? t("profile.consultancy&ProjectTitle")
        : null,
      this.props.userType === "INDIVIDUAL"
        ? t("profile.researchWorkTitle")
        : null,
      this.props.userType === "INDIVIDUAL"
        ? t("profile.training&ConferencesTitle")
        : null,
      this.props.userType === "INDIVIDUAL"
        ? t("profile.skillsAndEndorsements")
        : null,
      this.props.userType === "INDIVIDUAL" ? t("profile.achievements") : null,
    ];

    return (
      <div>
        <div
          style={{
            boxShadow: "0px 0px 20px #5555551a",
            padding: "20px",
            borderRadius: 10,
          }}
        >
          {feedTitle.map((title, idx) => {
            if (title !== null) {
              return (
                <div>
                  <Button
                    href={`#${title}`}
                    disableRipple
                    key={idx}
                    sx={{
                      textTransform: "none",
                      textAlign: "left",
                      color: "#606060",
                      p: "6px 8px",
                      width: "100%",
                      fontSize: "14px",
                      lineHeight: 1.2,
                      display: "flex",
                      justifyContent: "flex-start",
                      ":hover": {
                        color: "#F33070",
                        backgroundColor: "#fef7f8",
                        fontWeight: 600,
                      },
                    }}
                  >
                    {title}
                  </Button>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //U can destructure here to get only the required attributes from the state
  return {
    userType: state?.profile?.user?.user_type,
  };
};

export default withTranslation()(
  connect(mapStateToProps, null)(IconSectionFeed)
);
